/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AdminService } from './services/AdminService';
import { AppService } from './services/AppService';
import { AuthService } from './services/AuthService';
import { BenefitsService } from './services/BenefitsService';
import { BonusService } from './services/BonusService';
import { CompaniesService } from './services/CompaniesService';
import { ConversationsService } from './services/ConversationsService';
import { CostCentersService } from './services/CostCentersService';
import { DepartmentsService } from './services/DepartmentsService';
import { EmployeesService } from './services/EmployeesService';
import { FeatureFlagsService } from './services/FeatureFlagsService';
import { GoodiesService } from './services/GoodiesService';
import { GroupsService } from './services/GroupsService';
import { ImpexService } from './services/ImpexService';
import { IntegrationsService } from './services/IntegrationsService';
import { LegalDocumentsService } from './services/LegalDocumentsService';
import { LocationsService } from './services/LocationsService';
import { PaymentService } from './services/PaymentService';
import { ReceiptsService } from './services/ReceiptsService';
import { UserService } from './services/UserService';
import { VoucherService } from './services/VoucherService';
import { WebhooksService } from './services/WebhooksService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class PxtraClient {

    public readonly admin: AdminService;
    public readonly app: AppService;
    public readonly auth: AuthService;
    public readonly benefits: BenefitsService;
    public readonly bonus: BonusService;
    public readonly companies: CompaniesService;
    public readonly conversations: ConversationsService;
    public readonly costCenters: CostCentersService;
    public readonly departments: DepartmentsService;
    public readonly employees: EmployeesService;
    public readonly featureFlags: FeatureFlagsService;
    public readonly goodies: GoodiesService;
    public readonly groups: GroupsService;
    public readonly impex: ImpexService;
    public readonly integrations: IntegrationsService;
    public readonly legalDocuments: LegalDocumentsService;
    public readonly locations: LocationsService;
    public readonly payment: PaymentService;
    public readonly receipts: ReceiptsService;
    public readonly user: UserService;
    public readonly voucher: VoucherService;
    public readonly webhooks: WebhooksService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '/api/v1',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.admin = new AdminService(this.request);
        this.app = new AppService(this.request);
        this.auth = new AuthService(this.request);
        this.benefits = new BenefitsService(this.request);
        this.bonus = new BonusService(this.request);
        this.companies = new CompaniesService(this.request);
        this.conversations = new ConversationsService(this.request);
        this.costCenters = new CostCentersService(this.request);
        this.departments = new DepartmentsService(this.request);
        this.employees = new EmployeesService(this.request);
        this.featureFlags = new FeatureFlagsService(this.request);
        this.goodies = new GoodiesService(this.request);
        this.groups = new GroupsService(this.request);
        this.impex = new ImpexService(this.request);
        this.integrations = new IntegrationsService(this.request);
        this.legalDocuments = new LegalDocumentsService(this.request);
        this.locations = new LocationsService(this.request);
        this.payment = new PaymentService(this.request);
        this.receipts = new ReceiptsService(this.request);
        this.user = new UserService(this.request);
        this.voucher = new VoucherService(this.request);
        this.webhooks = new WebhooksService(this.request);
    }
}

